// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__17nLh","rtl":"Select_rtl__GSmV5"};